// Core
import React, { Component } from 'react';
import { connect } from 'react-redux';
// Styles
import './styles.scss';
// Components
import ManageGuestCount from './components/ManageGuests';

export class RsvpLiteGuestsPage extends Component {
    render() {
        return (
            <div className='rsvp-lite-container'>
                <ManageGuestCount
                    event={this.props.data.event}
                    eventAttendance={this.props.data.attendances}
                />
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        eventAttendance: store.eventAttendance,
        event: store.event,
    }
}

export default connect(mapStateToProps)(RsvpLiteGuestsPage);
